import { PageHeader } from "../components/PageHeader";
import { CommunityIntro } from "../components/CommunityIntro";
import { ModsGrid } from "../components/ModsGrid";
import { DiscordCTA } from "../components/DiscordCTA";

export const CommunityPage = () => {
    return (
        <div data-testid="community-page">
            <PageHeader
                eyebrow="The Crew"
                title="The community is the"
                accent="whole show."
                intro="None of this works without the chat. These are the people keeping it sharp, weird, and welcoming — meet the mod team and lock into the Discord."
                breadcrumbs={[{ label: "Home", href: "/" }, { label: "Community" }]}
            />
            <CommunityIntro />
            <ModsGrid />
            <DiscordCTA />
        </div>
    );
};
